/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { service } from '@ember/service';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

export default class Setup extends Component {
  @service
  options;

  @service
  router;

  @service
  store;

  @optionAlias('nswDOE:delInfo:name')
  delName;

  @optionAlias('hero:behaviours:doeContact')
  doePhoneNumber;

  @computed
  get nswDoeSchoolOption() {
    return this.store
      .peekAll('school-options/group')
      .find((group) => group.key === 'nswDOE');
  }

  @action
  toIncidents() {
    this.router.transitionTo('wellbeing.incidents');
  }

  @action
  toOptions() {
    if (!isEmpty(this.nswDoeSchoolOption)) {
      return this.router.transitionTo(
        'school-options.group',
        this.get('nswDoeSchoolOption.id'),
      );
    }
    this.router.transitionTo('school-options.basic-details');
  }
}
